exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.md-headline[data-v-600d9810]{height:55vh;overflow-y:auto\n}\n.md-dialog-content[data-v-600d9810]{padding:0px\n}\n.actions[data-v-600d9810]{margin:16px 16px 16px 0\n}\n.button[data-v-600d9810]{border-radius:5px;padding:0px;font-size:large\n}\n.title[data-v-600d9810]{display:flex;justify-content:center;font-style:italic;color:#3a3939\n}\n.moreInfo[data-v-600d9810]{font-size:16px;margin-top:10px;margin-left:8px\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-600d9810","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/mediaItem/AssociatedDialog.vue
// module id = 187
// module chunks = 0